export default "__VITE_ASSET__OQbiG6FH__"